import { render, staticRenderFns } from "./CommissionDetailsWeek.vue?vue&type=template&id=20a92ed4&"
import script from "./CommissionDetailsWeek.vue?vue&type=script&lang=js&"
export * from "./CommissionDetailsWeek.vue?vue&type=script&lang=js&"
import style0 from "./CommissionDetailsWeek.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports